import { Flex, Text } from "@gravity-ui/uikit";
import React from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { TextSection } from "../TextSection";
import { useWhyUsBlockTranslate } from "./hooks/useWhyUsBlockTranslate";

export const WhyUsBlock = () => {
  const { isMobile, isTablet, deviceText } = useGravityDevice();

  const { title, description, whyUsData } = useWhyUsBlockTranslate();

  return (
    <Flex
      id="why-us"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection title={title} description={description} />
      <Flex gap={6}>
        <Flex direction={"column"} gap={6}>
          {whyUsData.map((item, index, array) => {
            return (
              <React.Fragment key={`whyus.${index}`}>
                <Flex
                  gap={6}
                  alignItems={isMobile ? "start" : "center"}
                  justifyContent={"space-between"}
                  direction={isMobile ? "column" : "row"}
                >
                  <Flex gap={6} alignItems={"center"}>
                    <Text variant={deviceText.body}>{item.number}</Text>
                    <Text variant={deviceText.header}>{item.title}</Text>
                  </Flex>
                  <Text
                    variant={
                      isMobile ? "body-1" : isTablet ? "body-2" : "body-3"
                    }
                    style={{ lineHeight: 1.5, maxWidth: 800 }}
                  >
                    {item.description}
                  </Text>
                </Flex>

                {array.length !== index + 1 && (
                  <div
                    style={{
                      height: 1,
                      background: "var(--g-color-base-generic)",
                    }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};
